// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SearchResults":"jg_a bho_a bho_j bho_q bho_sv bho_sw bho_w"};